import { cn } from '@/platform/lib/utils';

const SegmentFooter = ({ className, children, ...props }) => (
    <div
        className={cn(
            'flex items-center justify-end gap-2 px-6 pt-8 pb-2',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export default SegmentFooter;
